// src/services/channelService.ts
import { AxiosResponse } from 'axios';
import apiClient from './apiClient';

/**
 * 公式アカウント向け：LINEチャネル情報取得 API
 * GET: /me/channel-info/
 */
export const getChannelInfo = async (): Promise<AxiosResponse> => {
  return apiClient.get('/users/me/channel-info/');
};

/**
 * 公式アカウント向け：LINEチャネル情報更新 API
 * PATCH: /me/channel-info/
 * @param data { line_channel_id?: string, line_access_token?: string, line_channel_secret?: string }
 */
export const updateChannelInfo = async (data: {
  line_channel_id?: string;
  line_access_token?: string;
  line_channel_secret?: string;
}): Promise<AxiosResponse> => {
  return apiClient.patch('/users/me/channel-info/', data);
};
